module.exports = __webpack_public_path__ + "6bafabc88676267e538f8c9d0db2b233.svg";